__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-custom-dimension/').replace(/[/]{3,}/g, "/");